import styled from 'styled-components'
import { mediaQueries } from 'theme'

export const StyledSpan = styled.span`
  margin-left: 10px;
  margin-right: 10px;
  @media ${mediaQueries.lessThanMedium} {
    margin-left: 5px;
    margin-right: 0;
  }
  color: white;
`

export const StyledButton = styled.button`
  display: flex;
  align-items: center;
  all: unset;
  font-size: 16px;
  font-weight: bold;
  margin-right: 24px;
  cursor: pointer;
  text-align: right;
  padding: 5px;
  white-space: nowrap;
  margin-left: 10px;
  margin-right: 10px;
  user-select: none;
  svg {
    color: white;
  }
  @media ${mediaQueries.lessThanMedium} {
    padding: 0;
    font-size: 12px;
  }
`
